import { createSelector } from 'reselect';
import { hasSavedRoomSelector } from '../roomMeasure';
import { hasSavedStepsSelector } from '../stairs';
import { hasSelectedCarpetSelector } from '../pricing';
import { hasSelectedCarpetPadSelector } from '../carpetPad';

export const stepsSelector = createSelector(
  (state) => state.steps,
  (isEdit) => isEdit,
  (isConfirmed) => isConfirmed,
  (isAdd) => isAdd,
);

export const canContinueSelector = createSelector(
  [hasSavedRoomSelector, hasSavedStepsSelector, hasSelectedCarpetSelector, hasSelectedCarpetPadSelector],
  (hasSavedRoom, hasSavedSteps, hasSelectedCarpet, hasSelectedCarpetPad) => {
    return (hasSavedRoom || hasSavedSteps) && hasSelectedCarpet && hasSelectedCarpetPad;
  }
);
